import { JetpacB2BApi } from 'api'

class B2bPendingPaymentsApi {
  static getPendingPayments(
    faberToken: string,
    params?: Record<string, string>
  ) {
    // Build query string if params provided
    const queryString = params
      ? Object.entries(params)
          .filter(([, value]) => value && value.trim() !== '')
          .map(
            ([key, value]) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
          )
          .join('&')
      : ''
    return JetpacB2BApi.httpGet(
      `/invoice/pending${queryString ? `?${queryString}` : ''}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
  static getOrderItems(faberToken: string, id: string) {
    return JetpacB2BApi.httpGet(
      `/invoice/order-items/${id}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }

}

export default B2bPendingPaymentsApi
